import instance from '../../api';

export const devicesEld = {
  async read(
    userId: string | number,
    model: string | number,
    eldVersion: string | number,
    appVersion: string | number,
    versionCode: string | number,
    device: string | undefined,
    searchEldType: string | undefined,
    sort: boolean | undefined | string,
    skip: number | undefined,
    companyId?: number | string | undefined,
  ) {
    if (userId === undefined) userId = '';

    const page = typeof skip === 'number' ? skip : 0;

    let isActive: boolean | undefined;

    if (sort === 'true') {
      isActive = true;
    } else if (sort === 'false') {
      isActive = false;
    }

    let companyIdParam: number | undefined;
    if (companyId !== undefined && companyId !== '') {
      const num = Number(companyId);
      if (isNaN(num)) {
        throw new Error('companyId is not a valid number');
      }
      companyIdParam = num;
    }

    const queryParams = [
      `page=${page}`,
      `perPage=10`,
      `userId=${encodeURIComponent(userId)}`,
      `searchModel=${encodeURIComponent(model)}`,
      `searchEldVersion=${encodeURIComponent(eldVersion)}`,
      `searchDeviceType=${encodeURIComponent(device ?? '')}`,
      `searchAppVersion=${encodeURIComponent(appVersion)}`,
      `searchVersionCode=${encodeURIComponent(versionCode)}`,
      `searchEldType=${encodeURIComponent(searchEldType ?? '')}`,
    ];

    if (isActive !== undefined) {
      queryParams.push(`isActive=${isActive}`);
    }

    if (companyIdParam !== undefined) {
      queryParams.push(`companyId=${companyIdParam}`);
    }

    const url = `devices/list?${queryParams.join('&')}`;

    const { data } = await instance(url);

    return {
      data: data.data,
      count: data.count,
    };
  },

  async deviceFinder(name: undefined | number | string) {
    const { data }: any = await instance(`devices/list?perPage=10&userId=${name}`);
    return data?.data;
  },

  async deviceFinderName(name: string) {
    const { data }: any = await instance(`users/searching-list?&searchName=${name}&driver=true`);
    return data?.data;
  },
};
